import React, { useEffect, useState, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { SurveyModal } from './components/ui/SurveyModal';
import { SurveyModalContext } from './hooks/use-survey-modal';
export function App() {
  const [isOpen, setIsOpen] = useState(false);
  // Inject tracking scripts
  useEffect(() => {
    // HeatSnap tracker
    if (!document.getElementById('heatsnap-tracker')) {
      const hs = document.createElement('script');
      hs.id = 'heatsnap-tracker';
      hs.src = 'https://heatmapsaas-zbdj9rd8.manus.space/tracker.js';
      hs.setAttribute('data-token', 'SO51aXA0MWJ-29cPen_sqG96cQi0WwEW');
      hs.async = true;
      document.body.appendChild(hs);
    }
    // Google Ads gtag.js
    if (!document.getElementById('gtag-script')) {
      const gtagScript = document.createElement('script');
      gtagScript.id = 'gtag-script';
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17996213147';
      gtagScript.async = true;
      document.head.appendChild(gtagScript);
      gtagScript.onload = () => {
        ;
        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).gtag = function (...args: any[]) {
          ;
          (window as any).dataLayer.push(arguments);
        };
        (window as any).gtag('js', new Date());
        (window as any).gtag('config', 'AW-17996213147');
      };
    }
    return () => {
      const hs = document.getElementById('heatsnap-tracker');
      if (hs) hs.remove();
      const gt = document.getElementById('gtag-script');
      if (gt) gt.remove();
    };
  }, []);
  return <SurveyModalContext.Provider value={{
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false)
  }} data-id="element-0">
      <LandingPage data-id="element-1" />
      <SurveyModal data-id="element-2" />
    </SurveyModalContext.Provider>;
}